export default __webpack_public_path__ + "static/media/ScriptEditingDoctoring.6ec12701.png";